module.exports = __webpack_public_path__ + "site/img/w.8eddffdf.png";